import { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Alert, message, Row, Col, Button, Form, Steps, Divider } from 'antd'
import { StepBackwardOutlined, StepForwardOutlined } from '@ant-design/icons'
import { setCurrentItem, setTab, setTabDisabled } from 'Actions/explore'
import { getUid } from 'Services/WeaverUtils'
import { NODE } from 'Types'
import {
  getNodeData
  createFormData
  editFormData
  fieldShouldRender
} from '../helpers'
import { parseErr } from 'Services/WeaverErrorHandler'
import SequencedFormInput from '../Inputs'
import WeaverService from 'Services/WeaverService'

{ Item } = Form
{ Step } = Steps

SequencedForm = ({
  destroy,
  formSequence,
  mode,
  nodeId,
  dataQueries,
  setError,
  formCallback,
  setCurrentItem,
  setTab,
  setTabDisabled
}) ->

  { sequence, formFields, onSave } = formSequence

  [loading, setLoading] = useState(true)
  [saving, setSaving] = useState(false)
  [formInputErr, setFormInputErr] = useState(undefined)
  [currentStep, setCurrentStep] = useState(0)
  [initialFormValues, setInitialFormValues] = useState()

  [form] = Form.useForm()

  callbacks = { setError }

  useEffect(->
    return if not nodeId
    (->
      fValues = await getNodeData(nodeId, formFields, dataQueries)
      form.setFieldsValue(fValues)
      setInitialFormValues(fValues)
      setLoading(false)
    )()
    undefined
  , [])

  changeFormStep = (direction) ->
    if direction is 'prev'
      setCurrentStep((val) -> (val - 1) or 0)
    else if direction is 'next'
      setCurrentStep((val) -> val + 1)

  handleError = (e) -> setFormInputErr(parseErr(e))

  errorFeedback = (
    <Alert
      showIcon
      style={{ marginBottom: '20px' }}
      message="Error submitting form"
      description={formInputErr}
      type="error"
    />
  )

  onFinish = (data) ->
    setFormInputErr(undefined)
    setSaving(true)
    try
      formData = _.chain(
        data
      ).omitBy(_.isNil)
      .mapValues((value, key) ->
        {
          value,
          initialValue: initialFormValues[key]
          fieldConfig: formFields.find(({ formItem }) -> formItem is key)
        }
      ).value()

      if mode is 'create'
        fn = createFormData
      else
        fn = editFormData

      formNode = await fn(nodeId, formData, onSave, dataQueries)

      if formCallback
        formCallback(formNode, formData)
      else
        setCurrentItem({
          id: getUid(formNode)
          graph: formNode.graph
          label: 'Test'
          type: NODE
        })
        setTabDisabled({ key: 'attributes', disabled: false })
        setTab('attributes')
      setSaving(false)
      await WeaverService.updateTypesMap()
      message.info(onSave.confirmation or "Save completed successfully.")
      destroy()
    catch e
      handleError(e)
      setSaving(false)

  getInitialFormValues = ->
    initialFormValues = {}
    sequence[currentStep].fields.filter((formField) ->
        if formField is 'id' and nodeId?
          false
        else if field = formFields.find(({ formItem }) -> formItem is formField)
          fieldShouldRender(form, field?.config?.conditions)
      ).map((formField, index) ->
        { formitemdefaultvalue } = formFields.find(({ formItem })-> formItem is formField)
        if formitemdefaultvalue?
          initialFormValues[formField] = formitemdefaultvalue
      )
    initialFormValues

  <Form
    form={form}
    name="sequencedForm"
    labelAlign="left"
    labelCol={span: 24}
    wrapperCol={span: 24}
    style={{ width: '100%' }}
    onFinish={onFinish}
    initialValues={getInitialFormValues()}
  >
    <Steps size="small" current={currentStep}>
      {sequence.map((step, index)->
        <Step key={"form-step-#{ index }"} title={"Step #{ ++index }"} />
      )}
    </Steps>
    <Divider />
    <div className="steps-content">
      {sequence[currentStep].fields.filter((formField) ->
        if formField is 'id' and nodeId?
          false
        else if field = formFields.find(({ formItem }) -> formItem is formField)
          fieldShouldRender(form, field?.config?.conditions)
      ).map((formField, index) ->
        { formItemLabel, formItemRules, formItemProps... } = formFields.find(({ formItem })-> formItem is formField)
        formItem = formItemProps.formItem
        <Item
          key={formItem}
          name={formItem}
          label={formItemLabel}
          rules={formItemRules or []}
          shouldUpdate
        >
          <SequencedFormInput
            { formItemProps... }
            nodeId={nodeId}
            form={form}
            queries={dataQueries}
            label={formItemLabel}
            callbacks={callbacks}
          />
        </Item>
      )}
    </div>
    { formInputErr && errorFeedback }
    <div className="steps-action">
      <Row>
        <Col span={16}>
          <Button
            disabled={currentStep is 0}
            icon={<StepBackwardOutlined />}
            style={{ marginRight: 10 }}
            onClick={-> changeFormStep('prev')}
          >
            Prev
          </Button>
          <Button
            disabled={!sequence[currentStep + 1]?}
            icon={<StepForwardOutlined />}
            onClick={->
              try
                await form.validateFields(sequence[currentStep].fields)
                changeFormStep('next')
              catch
                console.error 'validation failed'
            }
          >
            Next
          </Button>
        </Col>
        <Col span={8} style={{ textAlign: 'right' }}>
          <Button
            loading={saving}
            disabled={sequence[currentStep + 1]?}
            type="primary"
            htmlType="submit"
          >
            Save
          </Button>
        </Col>
      </Row>
    </div>
  </Form>

export default connect(null, { setCurrentItem, setTab, setTabDisabled })(SequencedForm)
